<script setup lang="ts">
import type { ComboboxItemProps } from "./combobox.types";
import { useComboboxItem } from "./useCombobox.Item";

defineOptions({ name: "ComboboxItem" });

const props = withDefaults(defineProps<ComboboxItemProps>(), {
  disabled: false,
  selectedIcon: "check",
  showSelectedIcon: true,
});

const { isHighlighted, isSelected, isDisabled, isVisible, color, variant, size, handleSelect } = useComboboxItem({
  props,
});
</script>

<template>
  <e-listbox-item
    v-show="isVisible"
    class="e-combobox-item"
    :value="value"
    :label="label"
    :disabled="isDisabled"
    :selected="isSelected"
    :color="color"
    :variant="variant"
    :size="size"
    :highlighted="isHighlighted"
    :selected-icon="selectedIcon ?? 'check'"
    :show-selected-icon="showSelectedIcon ?? true"
    :icon="icon"
    :leading="leading"
    :leading-icon="leadingIcon"
    :trailing="trailing"
    :trailing-icon="trailingIcon"
    :loading="loading"
    :loading-icon="loadingIcon"
    @select="handleSelect"
  >
    <slot />
  </e-listbox-item>
</template>

<style>
:host {
  display: contents;
}
</style>
